import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Action, Dispatch } from "redux";
import { createClientSalesCampaignActionCreator } from "../action/client_sales_campaign";
import ClientSalesCampaignComponent from "../component/client/campaign/client_sales_campaign";
import {
  IClientSalesCampaignDispatcher,
  createClientSalesCampaignDispatcher,
} from "../dispatcher/client_sales_campaign";
import { GetCustomersBySalesCampaignPageRequest } from "../request/customer_request";
import { AppState } from "../store/app_state";
import { ClientSalesCampaignState } from "../store/client_sales_campaign_store";

interface IProps extends RouteComponentProps<{}> {
  state: ClientSalesCampaignState;
  dispatcher: IClientSalesCampaignDispatcher;
}

interface IState {
  isInit: boolean;
}

// 開発・STG環境には本番で固定表示するエキスパートが存在しないため、
// 本番と同じ枚数になるようダミーユーザーを並べて固定表示する。
// 本番のみ指定されたエキスパートを表示する。
const DEV_DUMMY_CUSTOMER_ID = "I6xc7Rg717Q8AxpSwmDbIpuynyr2";

const fixedCustomerIDs = (forProd: string[]): string[] => {
  if (process.env.REACT_APP_LIBERA_ENV === "prod") {
    return forProd;
  }
  return forProd.map(() => DEV_DUMMY_CUSTOMER_ID);
};

export class ClientSalesCampaignContainer extends React.Component<
  IProps,
  IState
> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    const req: GetCustomersBySalesCampaignPageRequest =
      new GetCustomersBySalesCampaignPageRequest();

    // ① 営業戦略を担う営業責任者・COO系
    // 営業戦略
    req.salesStrategyCustomerIDs = fixedCustomerIDs([
      "VxuYRdtz9mdGobc3JBerl3TYfsj2", // 川口慶太郎
      "wdOQF2q4X2fB5rfM1cwMicPB9rU2", // 兼本卓明
      "z5zAn7MxzDNaUfLqFhDvIlqrkME2", // 山野翔太
      "8goXAx7GHHekOK5XxNCkEU2lV3J2", // 加藤一平
    ]);

    // COO、事業責任者
    req.cooCustomerIDs = fixedCustomerIDs([
      "atxE1YzCSib0B4MVWZv3FMbIJxc2", // 染矢幹基
      "ZYpo3PCGfoUVEn1Im5wRoichwEL2", // 吉村直樹
      "XSQSdJt1okQpjXc3OXrfDvFKI8k1", // 佐藤亮太
      "wQIZjHtDZyO7oDDe89kOhFQ2qXe2", // 伊藤雄剛
    ]);

    // KPI設計
    req.kpiCustomerIDs = fixedCustomerIDs([
      "DJgNeK73jdhTB5MrZkKz9vCX5Xv2", // 東谷龍
      "KOZivZfUqmektu2kWIHjiYhjgDF3", // 安田善美
      "Srdzx1cQhPOU4eCtH2vI4BSZZ7E3", // 永冨佳
      "CT8bxgNnaxNw5b8ZphVQm9n4Lbt2", // 杉山元紀
    ]);

    // ② パートナーセールス・アライアンス営業
    // パートナーセールス
    req.partnerSalesCustomerIDs = fixedCustomerIDs([
      "JXaOY8YqaIUg8CkbQoO4AzQJGcm1", // 高山清光
      "yjBG85eUVrccoX3gR5gx7KBlMXk1", // 高橋友裕
      "QdvAtJ9UHDWOgcMtgRhdVOOPFLs2", // 八木拓也
      "AALIfU5PaXe9dJw8P0x6ivlemJv1", // 高桑慎介
    ]);

    // アライアンス営業
    req.allianceCustomerIDs = fixedCustomerIDs([
      "5JSm8gjYLYcjq0CAgS1fa9h9t5E3", // 外山正志
      "mEjvhzZDj3NPu22N1vjE2HNrngv1", // 山田修
      "vzCqOTJZhxNdiSWXpzPB26ZpCkH3", // 佐野健
      "zkgkCO7jYkSvmc0IstbDQftwPGy2", // 児島智
    ]);

    // ③ 営業組織の効率化・仕組み化
    // 営業組織開発
    req.salesOrgDevCustomerIDs = fixedCustomerIDs([
      "fEcoH2lgnzWz2AToJc5TpEHGqJ02", // 松本雅紀
      "CSkIkrwB07gk3RQ4seWborDYjee2", // 川口貴宏
      "AfQZofrJQ7bL2WRjeXMVW4kKJwb2", // 宇田川洋平
      "fSoSPA0pVVPrWxbKpZbEzLFYJ7E3", // 立花一雲
    ]);

    // SFA、CRM活用
    req.sfaCrmCustomerIDs = fixedCustomerIDs([
      "FTSbqW2udfPkCQuYzqlVuLnNfZn2", // 寺本拓矢
      "QqomJxx00xfy7tB1R4JEhP6K9LA2", // 橋本珠希
      "pwcuinOrQHSdIoVvfMnWY7OyaHE2", // 伊藤基明
      "g9uQklslsyae3wwNZdbWIVSk2w03", // 標努
    ]);

    // セールスイネーブルメント（営業教育・仕組み化）
    req.salesEnablementCustomerIDs = fixedCustomerIDs([
      "VOM88wjWWJapO62d7FqhFYCgjh93", // 相澤加寿恵
      "56REmf2F0xc6UVdv7oQ1NwkXFEr1", // 高梨雄一
      "50WBbElNRgRKVFWMRpw08FX98Av2", // 佐瀬宏樹
      "lAx98XnK1lRLAPHxbEKC3XzHzoX2", // 伊藤啓二
    ]);

    // 営業DX
    req.salesDxCustomerIDs = fixedCustomerIDs([
      "KLMprMhIuoO8BT4WLmLNZEVlo7t2", // 諏訪太一
      "QUGGTWREobY2JBkVANN1COjczDC2", // 塘浩司
      "Q4Kfb3G1YbVT6uYJulHZUJf3yTl2", // 田村和久
      "hHXZzUfk3vbCEIAf2fNFbx0vBrS2", // 亀田重幸
    ]);

    // ④ インサイドセールス・カスタマーサクセス
    // インサイドセールス
    req.insideSalesCustomerIDs = fixedCustomerIDs([
      "8goXAx7GHHekOK5XxNCkEU2lV3J2", // 加藤一平
      "yRjBj9TJGtQ23deQZjR1901Drf92", // 畠山忠士
      "f2H2JZ51oMTlfT0SIVNx3JA4QOq1", // 原敬輔
      "aTQsors5fxfYW6PWiCsatEkg4HX2", // 釣田翔
    ]);

    // カスタマーサクセス
    req.customerSuccessCustomerIDs = fixedCustomerIDs([
      "r5RJXc0xMSSApaXlG1TgLjurHdC3", // 小林泰己
      "z4x63SvW8sPxQtdpk4uSRrFUtyo1", // 岡田奈津子
      "Z17fsDzhU4XpNzYt0MALCGMsNHX2", // 鈴木貴丸
      "gSX2mcQThXabbmGO9sLv4UX23A42", // 幸村拓貴
    ]);

    // LTV最大化
    req.ltvCustomerIDs = fixedCustomerIDs([
      "YBtrGXPmibVcH0Dgmr1iyxORSPa2", // 松下和誉
      "LE4rdMcBIgaQDsRUhF7zfWuAnen2", // 鈴木敬
    ]);

    // ⑤ グループ間・部門間の営業連携
    // グループ間営業連携
    req.groupSalesCustomerIDs = fixedCustomerIDs([
      "vWzEyf4Y8aOEevIn5nDKD2fdJQA3", // 久保亘
      "jrpBNnt0M4YnkIMe0t6ygIN0ZIx2", // 大竹哲史
    ]);

    // 部門間連携
    req.interDeptCustomerIDs = fixedCustomerIDs([
      "KLMprMhIuoO8BT4WLmLNZEVlo7t2", // 諏訪太一
      "FTSbqW2udfPkCQuYzqlVuLnNfZn2", // 寺本拓矢
    ]);

    // クロスセル設計
    req.crossSellCustomerIDs = fixedCustomerIDs([
      "BZ3J8ak5LNN1dbBrpkawFGhsHfn2", // 福島智晴
      "iuEc2ze9jHXecyp1LcopNQb17nk1", // 冨樫嘉一
    ]);

    this.props.dispatcher.getCustomers(req);
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { state } = this.props;
    const {
      salesStrategyCustomers,
      cooCustomers,
      kpiCustomers,
      partnerSalesCustomers,
      allianceCustomers,
      salesOrgDevCustomers,
      sfaCrmCustomers,
      salesEnablementCustomers,
      salesDxCustomers,
      insideSalesCustomers,
      customerSuccessCustomers,
      ltvCustomers,
      groupSalesCustomers,
      interDeptCustomers,
      crossSellCustomers,
      jobCareersWithCustomerID,
      clientBookmarks,
      isLoading,
    } = state;

    return (
      <ClientSalesCampaignComponent
        isLoading={isLoading}
        salesStrategyCustomers={salesStrategyCustomers}
        cooCustomers={cooCustomers}
        kpiCustomers={kpiCustomers}
        partnerSalesCustomers={partnerSalesCustomers}
        allianceCustomers={allianceCustomers}
        salesOrgDevCustomers={salesOrgDevCustomers}
        sfaCrmCustomers={sfaCrmCustomers}
        salesEnablementCustomers={salesEnablementCustomers}
        salesDxCustomers={salesDxCustomers}
        insideSalesCustomers={insideSalesCustomers}
        customerSuccessCustomers={customerSuccessCustomers}
        ltvCustomers={ltvCustomers}
        groupSalesCustomers={groupSalesCustomers}
        interDeptCustomers={interDeptCustomers}
        crossSellCustomers={crossSellCustomers}
        clientBookmarks={clientBookmarks}
        jobCareersWithCustomerID={jobCareersWithCustomerID}
      />
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientSalesCampaignReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientSalesCampaignDispatcher(
      dispatch,
      createClientSalesCampaignActionCreator()
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientSalesCampaignContainer);



// WEBPACK FOOTER //
// ./src/presentation/container/client_sales_campaign_container.tsx